import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrigamiResponse, ServiceBase } from './base/service.base';

export enum NavigationLinkType {
  SolutionOffering = 0,
  IAMApp = 1,
  DomainLink = 2,
  RoomLink = 3,
}

export interface NavigationLink {
  Id: string;
  ItemType: NavigationLinkType;
  Name: string;
  ShortDisplayName: string | null;
  SystemName: string | null;
  Icon: string | null;
  Color: string | null;
  TargetUrl: string;
  IsExternal: boolean;
  RoomsCount: number | null;
  SolutionOfferingId: number | null;
  Type: string | null;
}

export interface GetNavigationLinksResult {
  Links: NavigationLink[];
  ErrorRecords: { ErrorCode: number; ObjectName: string; ObjectId?: number }[];
}

@Injectable()
export class NavigationApiService extends ServiceBase {
  serviceUrl = 'NavigationService.svc';

  getNavigationLinks(siteId?: number): Observable<OrigamiResponse<GetNavigationLinksResult>> {
    return this.origamiPost('/GetNavigationLinks', siteId != null ? { siteId } : {}, null, []);
  }
}
